import React from 'react';
import { FaTwitch, FaSpotify } from 'react-icons/fa';
import '../../styles/Home.css';

/**
 * Props pour le composant PlatformBadges
 * @typedef {Object} PlatformBadgesProps
 * @property {Object|null} twitchUser - L'utilisateur Twitch connecté
 * @property {Object|null} spotifyUser - L'utilisateur Spotify connecté
 */

/**
 * Composant affichant les badges des plateformes connectées
 * Affiche un badge pour chaque plateforme (Twitch/Spotify) si l'utilisateur y est connecté
 *
 * @component
 * @param {PlatformBadgesProps} props - Les props du composant
 * @returns {JSX.Element} Les badges des plateformes
 */
const PlatformBadges = ({ twitchUser, spotifyUser }) => (
  <div className="platform-badges">
    {twitchUser && (
      <span className="platform-badge twitch">
        <FaTwitch />
        <span>Twitch</span>
      </span>
    )}
    {spotifyUser && (
      <span className="platform-badge spotify">
        <FaSpotify />
        <span>Spotify</span>
      </span>
    )}
  </div>
);

export default PlatformBadges;
